var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1877 9.27783C11.2386 9.27783 9.65283 10.8636 9.65283 12.8127C9.65283 14.7618 11.2386 16.3475 13.1877 16.3475C15.1368 16.3475 16.7225 14.7618 16.7225 12.8127C16.7225 10.8636 15.1368 9.27783 13.1877 9.27783Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3971 12.2096H22.0435C21.7456 7.79362 18.2064 4.25435 13.7904 3.9565V0.602941C13.7904 0.269716 13.5203 0 13.1875 0C12.8543 0 12.5846 0.269716 12.5846 0.602941V3.9565C8.16862 4.25435 4.62935 7.79362 4.3315 12.2096H0.977941C0.644716 12.2096 0.375 12.4793 0.375 12.8125C0.375 13.1453 0.644716 13.4154 0.977941 13.4154H4.3315C4.62935 17.8314 8.16862 21.3706 12.5846 21.6685V25.0221C12.5846 25.3549 12.8543 25.625 13.1875 25.625C13.5203 25.625 13.7904 25.3549 13.7904 25.0221V21.6685C18.2064 21.3706 21.7456 17.8314 22.0435 13.4154H25.3971C25.7299 13.4154 26 13.1453 26 12.8125C26 12.4793 25.7299 12.2096 25.3971 12.2096ZM13.1875 17.5532C10.5735 17.5532 8.44677 15.4265 8.44677 12.8125C8.44677 10.1985 10.5735 8.07177 13.1875 8.07177C15.8015 8.07177 17.9282 10.1985 17.9282 12.8125C17.9282 15.4265 15.8015 17.5532 13.1875 17.5532Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.b70156b3561dbdbeb4ca048092e50055.svg";
export { ForwardRef as ReactComponent };